document.addEventListener("turbolinks:load", function() {

  var hourButtons = document.getElementsByClassName('show-extra-hours');
  for (var i = 0; i < hourButtons.length; i++) {
    var btn = hourButtons[i];
    btn.addEventListener('click', toggleHours);
  }

  function toggleHours(event) {
    var containerId = event.target.dataset.day
    /*var btnValue = event.target.innerHTML

    if (btnValue == '+') {
      event.target.innerHTML = '-'
    } else {
      event.target.innerHTML = '+'
    }*/

    document.getElementById(containerId).classList.toggle("visually-hidden");
  }
});
